import React from "react";
import { STAGE_COLOR, STAGE_LABEL } from "@/lib/sales";
import { MapPin, Phone } from "lucide-react";

export default function LeadCard({ lead, onClick, draggable = false, onDragStart }) {
  const color = STAGE_COLOR[lead.status] || "#9ca3af";
  return (
    <div
      className="iz-card p-3 cursor-pointer hover:border-[#d4af37]/50 transition-colors relative"
      onClick={onClick}
      draggable={draggable}
      onDragStart={onDragStart}
      data-testid={`lead-card-${lead.id}`}
    >
      <span className="absolute top-0 left-3 w-8 h-0.5 rounded-b" style={{ background: color }}/>
      <div className="flex items-center justify-between mb-1.5 mt-1">
        <p className="text-sm text-white truncate">{lead.client_name}</p>
        <span className="text-[9px] font-mono uppercase tracking-widest text-gray-500">{STAGE_LABEL[lead.status]}</span>
      </div>
      <div className="flex flex-wrap gap-3 text-[11px] text-gray-400 font-mono">
        <span className="flex items-center gap-1"><Phone className="w-3 h-3"/>{lead.phone}</span>
        {lead.source && <span className="text-gray-500">· {lead.source}</span>}
      </div>
      {lead.meeting && (
        <p className="text-[10px] text-[#d4af37] mt-1.5 font-mono flex items-center gap-1">
          <MapPin className="w-3 h-3"/>{lead.meeting.date} {lead.meeting.time}
        </p>
      )}
    </div>
  );
}
